import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

const [w,d,mq] = [window,document,window.matchMedia('(max-width: 901px)')];

class scrollevent {
  constructor() {
    gsap.registerPlugin( ScrollTrigger );
    this.init();
  }
  init() {
    this.feature();
  }
  feature () {
    let container = d.querySelectorAll('.tech-feature.is-feature01');
    if( container.length ){
      let img01 = d.querySelector('.is-feature01 .tech-feature__img img');
      if(img01.complete) container[0].classList.add('is-ready');
      else img01.addEventListener('load', () => container[0].classList.add('is-ready') );
    }
    gsap.to('.is-feature01 .tech-feature__img img', {
      y: -130,
      scrollTrigger: {
        trigger: '.tech-feature.is-feature02',//アニメーションが始まるトリガーとなる要素
        start: 'top bottom', //アニメーションが始まる位置を指定
        end: 'bottom top',
        scrub: true,
        // markers: true,
      }
    });
  }
}

export default function TECHNICAL () {
  d.addEventListener('DOMContentLoaded', () => new scrollevent );
}